<script lang="ts" setup>
import { useMaintenanceSite } from '~/composables/common/use-maintenance-site'
import { RoutesEnum } from '~/enums/routes'

const { hasMaintenance } = useMaintenanceSite()
const maintenanceTime = useRuntimeConfig().public.MAINTENANCE_TIME || ''
const brandName = useRuntimeConfig().public.BRAND_NAME || ''
const [startTime, startDate, endTime, endDate] = maintenanceTime.split(' - ')
const maintenanceNote = `${startTime} - ${startDate} đến ${endTime} - ${endDate}`

if (!hasMaintenance.value) {
  navigateTo(RoutesEnum.Home)
}

const { isMobile } = useDevice()
</script>

<template>
  <div
    :class="{
      maintenance: true,
      container: !isMobile,
      'maintenance-mobile': isMobile,
    }"
  >
    <div class="maintenance__section">
      <div class="maintenance__image">
        <img src="/images/maintenance/maintenance.png" alt="maintenance" />
      </div>
      <div class="maintenance__content">
        <div class="maintenance__text">
          <div class="maintenance__title">Hệ thống đang bảo trì</div>
          <div class="maintenance__sub-title">
            {{ brandName }} đang tiến hành bảo trì hệ thống cải thiện chất lượng
            dịch vụ.
            <p>
              Thời gian bảo trì dự kiến từ:
              <span class="maintenance__note">
                {{ maintenanceNote }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/components/desktop/pages/maintenance/index.scss';
@import '~/assets/styles/components/responsive/mobile/pages/maintenance.scss';
</style>
